import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { InFlightDedupService } from 'services/in-flight-dedup.service';

export const inFlightDedupInterceptor: HttpInterceptorFn = (request, next) => {
  return inject(InFlightDedupService).handle$(request, next);
};
